module.exports = __webpack_public_path__ + "img/pasture_andropogon_low.07314d05.jpg";